import { render, staticRenderFns } from "./TopGames.vue?vue&type=template&id=74f7a5bb&scoped=true&"
import script from "./TopGames.vue?vue&type=script&lang=js&"
export * from "./TopGames.vue?vue&type=script&lang=js&"
import style0 from "./TopGames.vue?vue&type=style&index=0&id=74f7a5bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f7a5bb",
  null
  
)

export default component.exports